import { render, staticRenderFns } from "./ColorChanger.vue?vue&type=template&id=deab20ea&scoped=true"
import script from "./ColorChanger.vue?vue&type=script&lang=js"
export * from "./ColorChanger.vue?vue&type=script&lang=js"
import style0 from "./ColorChanger.vue?vue&type=style&index=0&id=deab20ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deab20ea",
  null
  
)

export default component.exports